import type { RouteObject } from 'react-router';
import SentinelLayout from '@/components/layouts/sentinel-layout';
import SentinelWorkspaceRoute from './sentinel-workspace';
import SentinelBenchmarkRoute from './sentinel-workspace-benchmark';

/** `/sentinel-workspace`: the ticket workspace and Benchmark, under the Sentinel sidebar for those who have Benchmark. */
export const sentinelWorkspaceRoute: RouteObject = {
  path: 'sentinel-workspace',
  element: <SentinelLayout />,
  handle: { subject: 'sentinel-workspace' },
  children: [
    { path: 'benchmark', element: <SentinelBenchmarkRoute /> },
    // The bare path and `/<ticket>` share this one route, so the workspace stays mounted while the ticket in the path
    // changes. A route without a path matches only through a child, hence the index child next to `*`.
    {
      element: <SentinelWorkspaceRoute />,
      children: [
        { index: true, element: null },
        { path: '*', element: null },
      ],
    },
  ],
};
